@import (reference) "../../../styles/variables.less";

:host {
  display: block;
  height: 100%;
  overflow-y: auto;
  position: relative;
}

button {
  background: none;
  border: none;
}

ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  text-align: left;
}

.nav-link {
  align-items: center;
  color: @white;
  cursor: pointer;
  display: flex;
  font: bold 16px/1 @lt-font-family-primary;
  justify-content: space-between;
  padding: @spacer-3;
  width: 100%;

  span {
    align-items: center;
    display: flex;
    gap: @spacer-3;
  }
}

.submenu {
  background-color: @lt-blue-deep-light-1;
  display: none;

  a {
    color: @white;
    display: block;
    font: bold 14px/1 @lt-font-family-primary;
    padding: @spacer-2b 0 @spacer-2b 56px;
    text-decoration: none;

    &:hover {
      color: @lt-green;
    }
  }

  &.open {
    display: block;
  }
}

.more-nav {
  border-top: 1px solid @lt-gray-dark-1;
  margin: @spacer-7 @spacer-3 0;
  padding: @spacer-3 0 @spacer-7;

  .slogan {
    color: @white;
    font: normal 16px/24px @lt-font-family-primary;
    margin-bottom: 16px;
  }

  .menu-sign-in-btn-block {
    display: flex;
    gap: 16px;

    a {
      align-items: center;
      border: 2px solid @white;
      border-radius: 35px;
      color: @white;
      display: flex;
      flex: 1 0 0;
      font: bold 14px/1 @lt-font-family-primary;
      height: 35px;
      justify-content: center;
      text-decoration: none;

      &:hover, &:focus {
        background-color: @lt-blue-dark-1;
        cursor: pointer;
      }
    }
  }
}
